import * as React from 'react';

import FileSpreadsheet16 from './FileSpreadsheet16';

export const fileSpreadsheet16 = () => <FileSpreadsheet16 />;

export default {
    title: 'Icon/Fill/FileSpreadsheet16',
    component: FileSpreadsheet16,
    parameters: {
        notes: "`import FileSpreadsheet16 from 'box-ui-elements/es/icon/fill/FileSpreadsheet16';`",
    },
};
